import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

function Sidebar({ currentPath }) {
  const isActive = (path) => currentPath === path || currentPath.startsWith(path + '/');

  return (
    <div className="admin-sidebar">
      <h2>ZEITECE Admin</h2>
      <nav>
        <ul className="admin-nav">
          <li>
            <Link to="/admin/dashboard" className={isActive('/admin/dashboard') ? 'active' : ''}>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/admin/users" className={isActive('/admin/users') ? 'active' : ''}>
              Benutzer &amp; Mandanten
            </Link>
          </li>
          <li>
            <Link to="/admin/licenses" className={isActive('/admin/licenses') ? 'active' : ''}>
              Lizenzen
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Sidebar;






